import { Card } from '@chakra-ui/react';
import { TaxProviderTypeEnum } from '@monetize/types/app';
import { FC } from 'react';
import {
  MCloseButton,
  MFlex,
  MImage,
  MText,
} from '../../../../../components/Monetize';
import { TAX_PROVIDER_DISPLAY } from '../../../../../constants/taxes';

export type CrmCardAction = 'RE-SYNC-CATALOG' | 'VERIFY' | 'DELETE';

interface TaxCardEditProps {
  type: TaxProviderTypeEnum;
  showCloseButton?: boolean;
  handleCancel?: () => void;
  children: React.ReactNode;
}

export const TaxCardEdit: FC<TaxCardEditProps> = ({
  type,
  showCloseButton = false,
  handleCancel = () => {},
  children,
}) => {
  return (
    <Card.Root variant="edit" w="37.5rem">
      <Card.Header>
        <MFlex justifyContent="space-between" alignItems="center">
          <MFlex alignItems="center">
            <MImage
              src={TAX_PROVIDER_DISPLAY[type].icon}
              maxW="80px"
              maxH="25px"
              objectFit="contain"
            />
            <MText mx={2} fontSize="14px">
              {TAX_PROVIDER_DISPLAY[type].name}
            </MText>
          </MFlex>
          {showCloseButton && <MCloseButton onClick={handleCancel} />}
        </MFlex>
      </Card.Header>
      <Card.Body>{children}</Card.Body>
    </Card.Root>
  );
};
